import styled from 'styled-components';
import { UICustomInputLabel } from '../../UI';

export const CartCouponTitle = styled(UICustomInputLabel)`
  margin-top: 20px !important;
`;
